export * from './TextAlignLeftJustifyIcon';
export * from './TextAlignLeftJustifyIcon16Light';
export * from './TextAlignLeftJustifyIcon16Regular';
export * from './TextAlignLeftJustifyIcon16Solid';
export * from './TextAlignLeftJustifyIcon20Light';
export * from './TextAlignLeftJustifyIcon20Regular';
export * from './TextAlignLeftJustifyIcon20Solid';
export * from './TextAlignLeftJustifyIcon24Regular';
export * from './TextAlignLeftJustifyIcon24Solid';
export * from './TextAlignLeftJustifyIcon32Regular';
export * from './TextAlignLeftJustifyIcon64Regular';
